import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { createContext, useCallback, useState } from 'react';
import { Box, Button, Dialog, Flex, Heading, Text } from '@applyboard/crystal-ui';
import { CheckHiFiIllustration } from "./CheckHiFiIllustration";
import { CircleCrossIllustration } from "./CircleCrossIllustration";
function LegacyAlertDialog(_ref) {
  var alertProps = _ref.alertProps,
    setAlertProps = _ref.setAlertProps;
  function onOpenChange(isOpen) {
    if (!isOpen) {
      setAlertProps(alertProps);
    }
  }
  return /*#__PURE__*/React.createElement(Dialog, {
    open: !!alertProps,
    onOpenChange: onOpenChange
  }, /*#__PURE__*/React.createElement(Dialog.Content, null, /*#__PURE__*/React.createElement(Flex, {
    justify: "center",
    direction: "column"
  }, /*#__PURE__*/React.createElement(Flex.Item, {
    basis: "9rem"
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    gap: 4,
    justify: "between",
    align: "center",
    height: "fill"
  }, /*#__PURE__*/React.createElement(Box, {
    p: 6
  }, (alertProps === null || alertProps === void 0 ? void 0 : alertProps.type) === 'success' ? /*#__PURE__*/React.createElement(CheckHiFiIllustration, null) : /*#__PURE__*/React.createElement(CircleCrossIllustration, null)), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    align: "center"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflowY: 'auto',
      maxHeight: 'calc(100vh - 288px)'
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    align: "center",
    level: 2
  }, alertProps === null || alertProps === void 0 ? void 0 : alertProps.title), /*#__PURE__*/React.createElement(Box, {
    pt: 2
  }, /*#__PURE__*/React.createElement(Text, {
    align: "center"
  }, alertProps === null || alertProps === void 0 ? void 0 : alertProps.text)))))))), /*#__PURE__*/React.createElement(Dialog.Actions, null, /*#__PURE__*/React.createElement(Flex, {
    justify: "center",
    grow: 1,
    pb: 2
  }, /*#__PURE__*/React.createElement(Button, {
    intent: "primary",
    onClick: function onClick() {
      return setAlertProps(null);
    }
  }, "Ok"))));
}
export var LegacyAlertContext = /*#__PURE__*/createContext(undefined);
export var LegacyAlertProvider = function LegacyAlertProvider(_ref2) {
  var children = _ref2.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    alertProps = _useState2[0],
    setAlertProps = _useState2[1];
  var showAlert = useCallback(function (props) {
    setAlertProps(props);
  }, []);
  return /*#__PURE__*/React.createElement(LegacyAlertContext.Provider, {
    value: {
      showAlert: showAlert
    }
  }, children, alertProps && /*#__PURE__*/React.createElement(LegacyAlertDialog, {
    alertProps: alertProps,
    setAlertProps: showAlert
  }));
};